export default __webpack_public_path__ + "static/media/homeaway.92519c79.png";